import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('lg')]: {
      backgroundColor: 'var(--color-backdrop-dull)',
      borderRadius: 4,
      paddingBottom: 4,
      paddingTop: 4,
      paddingLeft: 2,
      paddingRight: 2,
    },
  },
}));

const BubbleGridRow = ({ spacing = 2, className = '', children }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={spacing}
      className={`${classes.root} ${className} BubbleGridRow`}
    >
      {children}
    </Grid>
  );
};

export default BubbleGridRow;
